module.exports = __webpack_public_path__ + "img/logo.d7e70868.png";